import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Constants } from '../../utils/constants';
import { UtmService } from '../../utils/utm.service';
import { AnimationService } from '../../utils/animation.service';

@Component({
  selector: 'app-skills-dates',
  templateUrl: './skills-dates.component.html',
  styleUrls: ['../home.component.scss', './skills-dates.component.scss']
})
export class SkillsDatesComponent implements OnInit {
  formGenericUrl: string = Constants.formGenericUrl;
  @ViewChild('animation')
  animation: ElementRef;

  constructor(private animations: AnimationService, private route: ActivatedRoute, private utmService: UtmService) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(() => this.formGenericUrl = this.utmService.getFormPath());
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event) {
    this.animations.startRightToLeftAnimation(this.animation.nativeElement);
  }
}
